import React, { useReducer } from "react";
import { ContactContext } from "./ContactContext";
import { ContactReducer } from "./ContactReducer";
import { CONTACT } from "../../types";
import { baseUrl } from "../../config/config";
import { useMsal } from "@azure/msal-react";

const ContactState = (props) => {
  const { accounts } = useMsal();
  const initialState = {
    legalDocumentName: "privacyPolicy",
    company: "li",
    exist: true,
    isApproved: false,
    isActive: false,
    isPendingApproval: false,
    isSecondary: false,
    rucVendor: "",
    vendor: [{}],
    currentContact: null,
    primaryContact: {},
    secondaryContact: [],
    carrierContact: [],
    approvalSent: false,
    vendorCreated: false,
    isActivePrimary: false,
    isActiveSecondary: false,
    created: false,
    primaryContactCreated: false,
    secondContactCreated: false,
    //vendor
    vendorInformation: {},
    purchaseOrders: [],
    purchLines: [],
    startEnrollment: false,
    enrollment: false,
    legalDocument: {},
    personalData: {},
  };

  const [state, dispatch] = useReducer(ContactReducer, initialState);

  const getStates = async () => {
    //conectar con backend
    const localUrl =
      baseUrl +
      "/api/Person/Exist?localAccountGuId=" +
      accounts[0].localAccountId;
    const response = await fetch(localUrl);
    //si no existe devuelve response.status === 204
    if (response.status === 200) {
      const data = await response.json();
      if (data.useR_SIGNUP.filter((x) => x.useR_TYPE === 3).length > 0) {
        const userSignUp = data.useR_SIGNUP.filter((x) => x.useR_TYPE === 3)[0];
        let secondary = false;
        if (
          data.guiD_PRIMARY_CONTACT !== "" &&
          data.guiD_PRIMARY_CONTACT !== null
        ) {
          secondary = true;
        }
        const newData = {
          data: data,
          userSignUp: userSignUp,
          secondary: secondary,
        };
        dispatch({
          type: CONTACT.CURRENTCONTACT,
          payload: newData,
        });
      } else {
        dispatch({
          type: CONTACT.EXIST,
          payload: false,
        });
      }
    } else if (response.status === 500) {
      console.log("internal error");
    } else if (response.status === 204) {
      dispatch({
        type: CONTACT.EXIST,
        payload: false,
      });
    }
  };
  const getStatesContact = async () => {
    let dataVendor = {};
    const condActivePrimary =
      state.isActive &&
      state.isApproved &&
      !state.isPendingApproval &&
      !state.isSecondary &&
      state.exist;
    const condActiveSecondary =
      state.isActive &&
      state.isApproved &&
      !state.isPendingApproval &&
      state.isSecondary &&
      state.exist;
    if (condActivePrimary) {
      const guidPrimaryContact = accounts[0].localAccountId;
      let localUrl =
        baseUrl +
        "/api/VendorInformation/GetByGuid?guidPrimaryContact=" +
        guidPrimaryContact;
      const response = await fetch(localUrl);
      //si no existe devuelve response.status === 204
      if (response.status === 200) {
        dataVendor = await response.json();
      }
    }
    const data = {
      primary: condActivePrimary,
      secondary: condActiveSecondary,
      vendorInformation: dataVendor,
    };
    dispatch({
      type: CONTACT.ISACTIVE,
      payload: data,
    });
  };
  const getVendFlowEnrollment = async () => {
    const guid = accounts[0].localAccountId;
    const localUrl =
      baseUrl +
      "/api/VendFlowEnrollment/GetEnrollment?guidPrimaryContact=" +
      guid;
    const response = await fetch(localUrl);
    //si no existe devuelve response.status === 204
    if (response.status === 200) {
      const data = await response.json();
      dispatch({
        type: CONTACT.ENROLLMENT,
        payload: true,
      });
    }
  };
  const getIsSecondary = async () => {
    // if (state.currentContact) {
    //   const temp = state.currentContact.useR_SIGNUP.
    // }
    // dispatch({
    //   type: CONTACT.ISSECONDARY,
    //   payload: true,
    // });
  };
  const getVendor = async (ruc) => {
    let data = [];
    const response = await fetch(
      baseUrl + "/api/Vendor/" + ruc + "?company=" + state.company
    );
    if (response.status === 200) {
      data = await response.json();
    }
    dispatch({
      type: CONTACT.VENDOR,
      payload: [data],
    });
  };
  const getPrimaryContact = async (ruc) => {
    let localUrl =
      baseUrl + "/api/VendorInformation/GetGuidPrimaryContact?Ruc=" + ruc;
    const response = await fetch(localUrl);
    if (response.status === 200) {
      const guid = await response.text();
      localUrl = baseUrl + "/api/UserManager/GetUserByGuid?Guid=" + guid;
      const response2 = await fetch(localUrl);
      if (response2.status === 200) {
        const data = await response2.json();
        dispatch({
          type: CONTACT.PRIMARYCONTACT,
          payload: data,
        });
      }
    }
  };
  const getContactInformation = async (guid) => {
    let localUrl = baseUrl + "/api/UserManager/GetUserByGuid?Guid=" + guid;
    const response2 = await fetch(localUrl);
    if (response2.status === 200) {
      const data = await response2.json();
      dispatch({
        type: CONTACT.PRIMARYCONTACT,
        payload: data,
      });
      return data;
    }
  };
  const iFunctionGetSecondUser = async (data) => {
    let i = 0;
    let list = [];
    for (i; i < data.length; i++) {
      const response = await fetch(
        `${baseUrl}/api/UserManager/GetUserByGuid?Guid=${data[i].guid}`
      );
      if (response.status === 200) {
        const json = await response.json();
        json["mongoObj"] = data[i];
        list.push(json);
      }
    }
    return list;
  };
  const getAllSecondaryContact = async (guidPrimary) => {
    let data = [];
    let localUrl =
      baseUrl + "/api/Person/SecondaryContact?GuidPrimary=" + guidPrimary;
    const response = await fetch(localUrl);
    if (response.status === 200) {
      const respTmp = await response.json();
      data = await iFunctionGetSecondUser(respTmp);
    }
    dispatch({
      type: CONTACT.SECONDARYCONTACT,
      payload: data,
    });
  };
  const getAllCarrierContact = async (guidPrimary) => {
    try {
      let data = [];
      let localUrl =
        baseUrl + "/api/Person/CarrierContact?GuidPrimary=" + guidPrimary;
      const response = await fetch(localUrl);
      if (response.status === 200) {
        const respTmp = await response.json();
        data = await iFunctionGetSecondUser(respTmp);
        dispatch({
          type: CONTACT.CARRIERCONTACT,
          payload: data,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };
  const getLegalDocument = async () => {
    try {
      let localUrl =
        baseUrl +
        "/api/PortalLegalDocument?nameDocument=" +
        state.legalDocumentName;
      const response = await fetch(localUrl);
      if (response.status === 200) {
        const data = await response.json();
        dispatch({
          type: CONTACT.LEGALDOCUMENT,
          payload: data,
        });
        return data;
      }
    } catch (error) {
      console.log(error);
    }
  };
  const getPersonalData = async () => {
    try {
      let localUrl =
        baseUrl + "/api/PersonalData?GuidStr=" + accounts[0].localAccountId;
      const response = await fetch(localUrl);
      if (response.status === 200) {
        const data = await response.json();
        dispatch({
          type: CONTACT.PERSONALDATA,
          payload: data,
        });
        return data;
      }
    } catch (error) {
      console.log(error);
    }
  };
  //aprueba políticas de privacidad
  const postApproveAgreements = async (postData) => {
    console.log(JSON.stringify(postData));
    let localUrl = baseUrl + "/api/PersonalData/Create";
    const response = await fetch(localUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(postData),
    });

    if (response.status === 200) {
      const resp = await response.json();
      dispatch({
        type: CONTACT.PERSONALDATA,
        payload: resp,
      });
    }
  };
  //envía correo de políticas
  const postSendAgreements = async (postData) => {
    console.log(JSON.stringify(postData));
    let localUrl = baseUrl + "/api/PersonalData/Approve";
    const response = await fetch(localUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(postData),
    });

    if (response.status === 200) {
      const resp = await response.json();
      return resp;
    }
    return false;
  };
  //actualiza la información del contacto en AX
  const updateContactAX = async (postData) => {
    console.log(JSON.stringify(postData));
    let localUrl = baseUrl + "/api/Contact/Update";
    const response = await fetch(localUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(postData),
    });

    if (response.status === 200) {
      const resp = await response.json();
      return resp;
    }
    return false;
  };
  //actualiza la información del contacto en AzureAD
  const updateContactAD = async (postData) => {
    console.log(JSON.stringify(postData));
    let localUrl = baseUrl + "/api/UserManager/Update";
    const response = await fetch(localUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(postData),
    });

    if (response.status === 200) {
      const resp = await response.json();
      return resp;
    }
    return false;
  };
  const submitApproval = async () => {
    let data = false;
    const userName =
      accounts[0].idTokenClaims.given_name +
      " " +
      accounts[0].idTokenClaims.family_name;
    const urlEmail = window.location.origin + "/Approvals/";
    const toEmail = state.primaryContact.identities.filter(
      (x) => x.signInType === "emailAddress"
    )[0].issuerAssignedId;
    const postData = {
      // to: ["evillalobos@life.com.ec"],
      to: [`${toEmail}`],
      subject: "Laboratorios LIFE - Nueva aprobación - Portal de proveedores",
      content: `Estimad@,<br /><br />Se solicita la aprobación de contacto secundario para el usuario ${userName}.<br /><br />La aprobación la puede realizar dando clic en el siguiente enlace: <p><a href='${urlEmail}' >Ir a aprobaciones.</a></p><br />Saludos cordiales.`,
    };

    const localUrl = baseUrl + "/api/Email/Send";
    const response = await fetch(localUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(postData),
    });
    if (response.status === 200) {
      const resp = await response.json();
      if (resp[0] !== null) {
        data = true;
        await createSecondaryContact();
      } else {
        data = false;
      }
    }
    dispatch({
      type: CONTACT.APPROVALSENT,
      payload: data,
    });
  };
  const createPrimaryContact = async (data) => {
    let postData = accounts[0];
    //creamos el contacto en tabla Person
    postData["ruc"] = state.rucVendor;
    postData["cedula"] = data.cedula;
    postData["company"] = state.company;
    postData["base64AfiliacionIEES"] = data.fileUploaded;
    postData["guid_primary"] = "";
    postData["firstName"] = accounts[0].idTokenClaims.given_name;
    postData["lastName"] = accounts[0].idTokenClaims.family_name;
    postData["localAccountId"] = accounts[0].localAccountId;
    //info para creación de la información del contacto en AX
    postData["description"] = "VSS - Email";
    postData["locator"] = accounts[0].username; //correo
    postData["type"] = 2; //2 = Email
    postData["isPrimary"] = 1; //1 = Yes

    let localUrl = baseUrl + "/api/Person/Create";
    const response = await fetch(localUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(postData),
    });

    if (response.status === 200) {
      const resp = await response.json();
      //creamos el contacto en AX
      const respCreateContact = await createContactAX(
        postData,
        1,
        data.fileUploaded
      );
      //enviamos a la verificación del documento del IESS
      console.log(respCreateContact);
      if (respCreateContact) {
        iFunctionSendApprovalPrimaryContact(postData);
        dispatch({
          type: CONTACT.PRIMARY_CREATED,
          payload: true,
        });
      }
    }
  };
  //envía a aprobación el usuario
  const iFunctionSendApprovalPrimaryContact = async (postData) => {
    let localUrl = baseUrl + "/api/Contact/Primary/Approval";
    const response = await fetch(localUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(postData),
    });

    if (response.status === 200) {
      return true;
    }
  };
  //crea un contacto secundario en Mongo
  const createSecondaryContact = async () => {
    let postData = accounts[0];
    postData["ruc"] = state.rucVendor;
    postData["guid_primary"] = state.primaryContact.id;
    let localUrl = baseUrl + "/api/Person/Create";
    const response = await fetch(localUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(postData),
    });

    if (response.status === 200) {
      const resp = await response.json();
      dispatch({
        type: CONTACT.SECONDARY_CREATED,
        payload: true,
      });
    }
  };
  //crea un contacto TRANSPORTISTA en Mongo
  const createCarrierContact = async (carrier) => {
    try {
      carrier["guidPrimary"] = accounts[0].localAccountId;
      carrier["emailPrimary"] = accounts[0].username;
      let localUrl = baseUrl + "/api/Person/Carrier/Create";
      const response = await fetch(localUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(carrier),
      });
      if (response.status === 200) {
        const resp = await response.json();
        return true;
      }
    } catch (error) {}
  };
  //Elimina el contacto transportista
  const deleteCarrierContact = async (guidContactPerson) => {
    try {
      let localUrl =
        baseUrl + "/api/Person/Carrier/Delete?guid=" + guidContactPerson;
      const response = await fetch(localUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (response.status === 200) {
        const resp = await response.json();
        return true;
      }
    } catch (error) {}
  };
  //resetea la contraseña de un contacto TRANSPORTISTA
  const resetPasswordCarrierContact = async (postData) => {
    try {
      const localUrl = baseUrl + "/api/Person/Carrier/ResetPassword";
      const response = await fetch(localUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(postData),
      });

      if (response.status === 200) {
        const resp = await response.json();
        return true;
      }
    } catch (error) {}
  };
  const createContactAX = async (
    postData,
    typeContact,
    base64AfiliacionIEES
  ) => {
    //creamos el contacto en AX
    const contactAX = {
      custAccount: postData.ruc,
      firstName: postData.firstName,
      liActiveDirectoryGuid: postData.localAccountId,
      liTypeContact: typeContact,
      lastName: postData.lastName,
      location: postData.location,
      logisticsAddressCountryRegionId: "",
      middleName: "",
      primaryContactReference: postData.guid_primary,
      recId: 0, //recId siempre es 0, en el portal no se necesita
      description: postData.description,
      locator: postData.locator,
      isPrimary: postData.isPrimary,
      type: postData.type,
    };
    let localUrl = baseUrl + "/api/Contact/Create?company=" + state.company;
    const respCont = await fetch(localUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(contactAX),
    });
    if (respCont.status === 200) {
      //Creamos la información del proveedor (VendInformation)
      const rspVI = await iFunctionCreateVendorInformation();
      //creamos la entidad de documentación del proveedor (VendDocumentation)
      if (typeContact === 1) {
        const rspVD = await iFunctionCreateVendorDocumentation(
          base64AfiliacionIEES
        );
      }
      const tmp = {
        approvalSent: true,
        created: true,
        vendorCreated: rspVI,
      };
      dispatch({
        type: CONTACT.CREATED,
        payload: tmp,
      });
      return true;
    }
    return false;
  };
  const iFunctionCreateVendorInformation = async () => {
    let postData = accounts[0];
    postData["ruc"] = state.rucVendor;
    postData["company"] = state.company;
    if (Object.keys(state.primaryContact).length > 0) {
      postData["guid_primary"] = state.primaryContact.id;
    } else {
      postData["guid_primary"] = "";
    }
    const localUrl = baseUrl + "/api/VendorInformation/Create";
    const response = await fetch(localUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(postData),
    });

    if (response.status === 200) {
      const resp = await response.json();
      if (resp !== null) {
        return true;
      }
    }
    return false;
  };
  //CREA LA ENTIDAD DE DOCUMENTACIÓN DEL PROVEEDOR CUANDO SE ASIGNA UN CONTACTO PRIMARIO
  const iFunctionCreateVendorDocumentation = async (base64AfiliacionIEES) => {
    const postData = {
      guiD_VEND: accounts[0].localAccountId,
      entitY_ID: "",
      cedula: "",
      cedulA_RZ: "",
      obligacioneS_IESS: "",
      obligacioneS_IESS_RZ: "",
      registrO_UNICO: "",
      registrO_UNICO_RZ: "",
      referenciA_CLIENTES: "",
      referenciA_CLIENTES_RZ: "",
      certificadO_BANCARIO: "",
      declaracioN_IMP_RENTA: "",
      declaracioN_IVA: "",
      nombramientO_REPRESENTANTE_LEGAL: "",
      nombramientO_REPRESENTANTE_LEGAL_RZ: "",
      informE_RESPONSABILIDAD_SOCIAL: "",
      visioN_MISION_VALORES: "",
      estandareS_ETICOS: "",
      declaracion: "",
      afiliacioN_IESS_CONTACTO: base64AfiliacionIEES,
    };
    let localUrl = baseUrl + "/api/VendDocumentation/Create";
    const response = await fetch(localUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(postData),
    });

    if (response.status === 200) {
      const resp = await response.json();
      if (resp !== null) {
        return true;
      }
    }
    return false;
  };
  const createVendorInformation = async () => {
    let postData = accounts[0];
    postData["ruc"] = state.rucVendor;
    if (Object.keys(state.primaryContact).length > 0) {
      postData["guid_primary"] = state.primaryContact.id;
    } else {
      postData["guid_primary"] = "";
    }
    const localUrl = baseUrl + "/api/VendorInformation/Create";
    const response = await fetch(localUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(postData),
    });

    if (response.status === 200) {
      const resp = await response.json();
      if (resp !== null) {
        dispatch({
          type: CONTACT.VENDORCREATED,
          payload: true,
        });
      }
    }
  };
  const setCompany = (data) => {
    dispatch({
      type: CONTACT.COMPANY,
      payload: data,
    });
  };
  const setRucVendor = (ruc) => {
    dispatch({
      type: CONTACT.RUCVENDOR,
      payload: ruc,
    });
  };
  const setStartEnrollment = async (data) => {
    dispatch({
      type: CONTACT.START_ENROLLMENT,
      payload: data,
    });
  };
  const setResetPassword = async (postData) => {
    const localUrl = baseUrl + "/api/UserManager/ResetPasswordByGuid";
    const response = await fetch(localUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(postData),
    });

    if (response.status === 200) {
      const userName =
        accounts[0].idTokenClaims.given_name +
        " " +
        accounts[0].idTokenClaims.family_name;
      const postEmailData = {
        to: [`${postData.email}`],
        subject: "Laboratorios LIFE - Cambio de clave - Portal de proveedores",
        content: `Estimad@, ${
          postData.firstName + " " + postData.lastName
        }.<br /><br />El usuario ${userName} ha modificado su clave de acceso al portal.<br />Saludos cordiales.`,
      };
      const localUrl2 = baseUrl + "/api/Email/Send";
      const response2 = await fetch(localUrl2, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(postEmailData),
      });

      if (response2.status === 200) {
        const resp = await response2.json();
        if (resp[0] !== null) {
          return true;
        }
      }
    }
    return false;
  };
  const setApproval = async (infoContact) => {
    const guidPrimaryContact = accounts[0].localAccountId;
    let localUrl =
      baseUrl +
      "/api/VendorInformation/GetByGuid?guidPrimaryContact=" +
      guidPrimaryContact;
    const response = await fetch(localUrl);
    //si no existe devuelve response.status === 204
    if (response.status === 200) {
      const dataVendor = await response.json();
      const data = {
        guid: infoContact.id,
        comments: "Aprobador por " + guidPrimaryContact,
        activE_STATE: true,
        approvaL_STATE: true,
        pendinG_APPROVAL: false,
        baW_APPROVAL: false,
        iS_PRIMARY: false,
      };
      localUrl = baseUrl + "/api/Person/Approved";
      const responseApp = await fetch(localUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });
      if (responseApp.status === 200) {
        //creamos el contacto en el AX
        let postData = {};
        postData["ruc"] = dataVendor.ruc;
        postData["localAccountId"] = infoContact.id;
        postData["guid_primary"] = guidPrimaryContact;
        postData["firstName"] = infoContact.givenName;
        postData["lastName"] = infoContact.surname;
        postData["email"] = infoContact.mail;
        //info para creación de la información del contacto
        postData["description"] = "VSS - Email";
        postData["locator"] = infoContact.mail; //correo
        postData["type"] = 2; //2 = Email
        postData["isPrimary"] = 1; //1 = Yes, 0 = NO
        await createContactAX(postData, 2);

        const userName =
          accounts[0].idTokenClaims.given_name +
          " " +
          accounts[0].idTokenClaims.family_name;
        const urlEmail = window.location.origin;
        const postEmailData = {
          to: [`${postData.email}`],
          subject:
            "Laboratorios LIFE - Usuario aprobado - Portal de proveedores",
          content: `Bienvenid@, ${
            postData.firstName + " " + postData.lastName
          }.<br /><br />El usuario ${userName} ha aprobado su solicitud de acceso al portal.<br /><br /><p><a href='${urlEmail}' >Ir al sitio.</a></p><br />Saludos cordiales.`,
        };
        const localUrl2 = baseUrl + "/api/Email/Send";
        const response2 = await fetch(localUrl2, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(postEmailData),
        });

        if (response2.status === 200) {
          const resp = await response2.json();
          if (resp[0] !== null) {
            dispatch({
              type: CONTACT.VEND_INFORMATION,
              payload: {
                ruc: dataVendor.ruc,
                vendorInformation: dataVendor,
              },
            });
            return true;
          }
        }
      }
    }
    return false;
  };
  const setDelete = async (postData) => {
    const data = {
      guid: postData.guid,
      comments: postData.comments,
    };
    const localUrl = baseUrl + "/api/Person/Delete";
    const response = await fetch(localUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });

    if (response.status === 200) {
      return true;

      // const userName =
      //   accounts[0].idTokenClaims.given_name +
      //   " " +
      //   accounts[0].idTokenClaims.family_name;
      // const urlEmail = window.location.origin;
      // const postEmailData = {
      //   to: [`${postData.email}`],
      //   subject: "Laboratorios LIFE - Usuario aprobado - Portal de proveedores",
      //   content: `Bienvenid@, ${
      //     postData.firstName + " " + postData.lastName
      //   }.<br /><br />El usuario ${userName} ha aprobado su solicitud de acceso al portal.<br /><br /><p><a href='${urlEmail}' >Ir al sitio.</a></p><br />Saludos cordiales.`,
      // };
      // const localUrl2 = baseUrl + "/api/Email/Send";
      // const response2 = await fetch(localUrl2, {
      //   method: "POST",
      //   headers: {
      //     "Content-Type": "application/json",
      //   },
      //   body: JSON.stringify(postEmailData),
      // });

      // if (response2.status === 200) {
      //   const resp = await response2.json();
      //   if (resp[0] !== null) {
      //     return true;
      //   }
      // }
    }
    return false;
  };
  //Vendor
  const getInvoices = async () => {
    let guidPrimary = "";
    if (state.currentContact.guiD_PRIMARY_CONTACT !== "") {
      guidPrimary = state.currentContact.guiD_PRIMARY_CONTACT;
    } else {
      guidPrimary = state.currentContact.guid;
    }
    let localUrl =
      baseUrl +
      "/api/VendorInformation/GetByGuid?guidPrimaryContact=" +
      guidPrimary;
    const response1 = await fetch(localUrl);
    //si no existe devuelve response.status === 204
    if (response1.status === 200) {
      const dataVendor = await response1.json();
      //0991449868001
      //1790142981001
      const accountNum = dataVendor.ruc;
      let localUrl =
        baseUrl +
        "/api/Invoice?accountNum=" +
        accountNum +
        "&company=" +
        dataVendor.company;
      // const response = await fetch(
      //   "https://localhost:44365/api/Invoice?accountNum=" +
      //     accountNum +
      //     "&company=li"
      // );
      const response = await fetch(localUrl);
      const data = await response.json();
      sessionStorage.setItem("invoices", JSON.stringify(data));
      dispatch({
        type: CONTACT.VEND_INFORMATION,
        payload: {
          ruc: dataVendor.ruc,
          vendorInformation: dataVendor,
        },
      });
      return data;
    }
  };
  const getOpenPurchaseOrders = async (purchState) => {
    let data;
    let guidPrimary = "";
    if (state.currentContact.guiD_PRIMARY_CONTACT !== "") {
      guidPrimary = state.currentContact.guiD_PRIMARY_CONTACT;
    } else {
      guidPrimary = state.currentContact.guid;
    }
    let localUrl =
      baseUrl +
      "/api/VendorInformation/GetByGuid?guidPrimaryContact=" +
      guidPrimary;
    const response1 = await fetch(localUrl);
    //si no existe devuelve response.status === 204
    if (response1.status === 200) {
      const dataVendor = await response1.json();
      console.log(dataVendor);
      dispatch({
        type: CONTACT.VEND_INFORMATION,
        payload: {
          ruc: dataVendor.ruc,
          vendorInformation: dataVendor,
        },
      });
      //1790142981001 - PROVEXT-00003
      const accountNum = dataVendor.ruc;
      localUrl =
        baseUrl +
        "/api/Vendor/purch?vendAccount=" +
        accountNum +
        // "PROVEXT-00003" +
        "&purchState=" +
        purchState +
        "&company=" +
        dataVendor.company +
        "&country=" +
        dataVendor.country;
      const response = await fetch(localUrl);
      if (response.status === 200) {
        data = await response.json();
        console.log(data);
      }
      if (data) {
        dispatch({
          type: CONTACT.PURCHASE_ORDERS,
          payload: data,
        });
      }
    }
  };
  const setPurchLines = async (data) => {
    dispatch({
      type: CONTACT.PURCH_LINES,
      payload: data,
    });
  };
  const getPurchLines = async (purchId) => {
    let localUrl =
      baseUrl +
      "/api/Vendor/purch/line?purchId=" +
      purchId +
      "&company=" +
      state.vendorInformation.company;
    const response1 = await fetch(localUrl);
    //si no existe devuelve response.status === 204
    if (response1.status === 200) {
      const data = await response1.json();
      dispatch({
        type: CONTACT.PURCH_LINES,
        payload: data,
      });
    }
  };
  const getBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };
  return (
    <ContactContext.Provider
      value={{
        company: state.company,
        exist: state.exist,
        isActive: state.isActive,
        isApproved: state.isApproved,
        isPendingApproval: state.isPendingApproval,
        isSecondary: state.isSecondary,
        currentContact: state.currentContact,
        vendor: state.vendor,
        primaryContact: state.primaryContact,
        secondaryContact: state.secondaryContact,
        rucVendor: state.rucVendor,
        approvalSent: state.approvalSent,
        isActivePrimary: state.isActivePrimary,
        isActiveSecondary: state.isActiveSecondary,
        purchaseOrders: state.purchaseOrders,
        purchLines: state.purchLines,
        created: state.created,
        startEnrollment: state.startEnrollment,
        enrollment: state.enrollment,
        primaryContactCreated: state.primaryContactCreated,
        secondContactCreated: state.secondContactCreated,
        vendorInformation: state.vendorInformation,
        carrierContact: state.carrierContact,
        legalDocument: state.legalDocument,
        personalData: state.personalData,
        getStates,
        getIsSecondary,
        setCompany,
        setRucVendor,
        getVendor,
        getPrimaryContact,
        getContactInformation,
        getAllSecondaryContact,
        getAllCarrierContact,
        getVendFlowEnrollment,
        getLegalDocument,
        getPersonalData,
        postApproveAgreements,
        postSendAgreements,
        updateContactAX,
        updateContactAD,
        submitApproval,
        createPrimaryContact,
        createVendorInformation,
        createCarrierContact,
        deleteCarrierContact,
        resetPasswordCarrierContact,
        getStatesContact,
        setResetPassword,
        setApproval,
        setDelete,
        setStartEnrollment,
        //Vendor
        getInvoices,
        getPurchLines,
        setPurchLines,
        getOpenPurchaseOrders,
        getBase64,
      }}
    >
      {props.children}
    </ContactContext.Provider>
  );
};

export default ContactState;
